<template>
	<section>

        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-date-picker @change="changeSearchMonth"
                            v-model="filters.searchMonth"
                            value-format="yyyy-MM"
                            placeholder="Search by Month"
                            type="month">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button :disabled="!isEnable" type="primary" v-if="user.userNo == 'user-bcfde657d5684dd694d89ae424f11530'" @click="testGenStorageFeeByDaily">Build Storage Fee for Today</el-button>
                    <el-button :disabled="!isEnable" type="primary" v-if="user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || user.userNo == 'user-bcfde657d5684dd694d89ae424f11530'" @click="testGenStorageFeeByMonthly">Build Storage Fee for Month</el-button>
                    <el-button :disabled="!isEnable" type="primary" v-if="user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || user.userNo == 'user-bcfde657d5684dd694d89ae424f11530'" @click="showRebuildStorageFeeByDailyWin">Rebuild Storage Fee for Daily</el-button>
                    <el-button :disabled="!isEnable" type="primary" v-if="user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || user.userNo == 'user-bcfde657d5684dd694d89ae424f11530'" @click="showRebuildStorageFeeByMonthWin">Rebuild Fee for Month</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-table stripe :data="storageFeePayments" highlight-current-row v-loading="loading" 
                  style="width: 100%;">
            <el-table-column type="index">
            </el-table-column>
            <el-table-column prop="doctorName" label="Doctor">
            </el-table-column>
            <el-table-column prop="userName" label="Warehouse">
            </el-table-column>
            <el-table-column prop="reportMonth" label="Report Month">
            </el-table-column>
            <el-table-column prop="totalFee" label="Total Fee">
                <template slot-scope="scope">
                    {{formatMoney(scope.row.totalFee,2)}}
                </template>
            </el-table-column>
            <el-table-column prop="payStatus" label="Status">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.payStatus==0 && scope.row.totalFee > 0" type="info">Created</el-tag>
                    <el-tag v-else-if="scope.row.payStatus==0 && scope.row.totalFee <= 0" type="success">No need to pay</el-tag>
                    <el-tag v-else-if="scope.row.payStatus==1" type="success">Confirmed</el-tag>
                    <el-tag v-else-if="scope.row.payStatus==2" type="warning">Canceled</el-tag>
                    <el-tag v-else-if="scope.row.payStatus==3">Archived</el-tag>
                    <el-tag v-else-if="scope.row.payStatus==4" type="danger">Rejected</el-tag>
                    <el-tag v-else-if="scope.row.payStatus==5" type="warning">Requested</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="Action">
                <template slot-scope="scope" >
                    <el-button size="small" @click="getStorageFeePaymentSummary(scope.row.id)">
                        Detail
                    </el-button>
                    <el-button v-if="scope.row.totalFee > 0" type="small" v-on:click="showPaymentList(scope.row)" >Payment</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="changeStorageFeePayment" :page-size="pageSize"
                           :total="storageFeePaymentTotal" style="float:right;">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="Warehouse Fee Detail" width="90%" :visible.sync="warehouseFeeDetailModelVisible" :close-on-click-modal="false">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters">
                    <el-form-item>
                        <el-input v-model="filters.productName" placeholder="ProductName" @keyup.enter.native="getStorageFeePaymentDetail(null,1)" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" v-on:click="getStorageFeePaymentDetail(null,1)">Search</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="exportExcel('/excel/exportWarehouseFeeDetail','Warehouse Fee Detail.xls',1)">Export</el-button>
                    </el-form-item>
                    <el-form-item style="float:right;">
                        <el-select clearable placeholder="Filter Fee Type" v-model="filters.feeType" :filterable="true" @change="getStorageFeePaymentDetail(null,1)">
                            <el-option v-for="(fee,index) in feeTypeList" :label="fee.value"
                                       :value="fee.id" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </el-col>
            <!--列表-->
            <el-table stripe :data="warehouseFeeDetail" highlight-current-row v-loading="warehouseFeeLoading"
                      style="width: 100%;">
                <el-table-column prop="id" label="#">
                </el-table-column>
                <el-table-column prop="feeType" label="Fee Type">
                    <template slot-scope="scope" >
                        <p v-if="scope.row.feeType==0">Inbound</p>
                        <p v-if="scope.row.feeType==1">Outbound</p>
                        <p v-if="scope.row.feeType==2">Storage</p>
                    </template>
                </el-table-column>
                <el-table-column prop="productName" label="Product">
                </el-table-column>
                <el-table-column prop="upc" label="UPC">
                </el-table-column>
                <el-table-column prop="totalFee" label="Total Fee">
                    <template slot-scope="scope">
                        ${{formatMoney(scope.row.totalFee,4)}}
                    </template>
                </el-table-column>
                <el-table-column prop="productSize" label="Category">
                </el-table-column>
                <el-table-column prop="baseFee" label="Storage Fee">
                </el-table-column>
                <el-table-column prop="baseFeeOver" label="Storage > Years Fee">
                </el-table-column>
                <el-table-column prop="qty" label="Storage Qty">
                </el-table-column>
                <el-table-column prop="inboundFee" label="Inbound Fee">
                </el-table-column>
                <el-table-column prop="inboundRate" label="Inbound Rate">
                </el-table-column>
                <el-table-column prop="inboundQty" label="Inbound Qty">
                </el-table-column>
                <el-table-column prop="outboundFee" label="Outbound Fee">
                </el-table-column>
                <el-table-column prop="outboundRate" label="Outbound Rate">
                </el-table-column>
                <el-table-column prop="outboundQty" label="Outbound Qty">
                </el-table-column>
                <el-table-column prop="serviceFee" label="Service Fee">
                </el-table-column>
                <el-table-column prop="serviceType" label="Service Type">
                </el-table-column>
                <el-table-column prop="serviceQty" label="Service Qty">
                </el-table-column>
                <el-table-column prop="splitPackagesNum" label="Package Num">
                </el-table-column>
                <el-table-column prop="inboundDate" label="Inbound Date">
                    <template slot-scope="scope">
                        {{dateFormat(scope.row.inboundDate)}}
                    </template>
                </el-table-column>
                <el-table-column prop="reportDate" label="Report Date">
                    <template slot-scope="scope">
                        {{dateFormat(scope.row.reportDate)}}
                    </template>
                </el-table-column>
                <el-table-column prop="descs" label="Desc">
                </el-table-column>
            </el-table>

            <!--工具条-->
            <el-col :span="24" class="toolbar">
                <el-pagination layout="prev, pager, next" @current-change="changeWarehouseFeeDetail"
                               :page-size="pageSize" :total="warehouseFeeDetailTotal" :current-page.sync="warehouseFeeDetailPage"
                               style="float:right;">
                </el-pagination>
            </el-col>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="warehouseFeeDetailModelVisible = false">Close</el-button>
            </div>
        </el-dialog>

        <!--编辑界面-->
        <el-dialog title="Warehouse Fee Summary" width="80%" :visible.sync="warehouseFeeSummaryModelVisible" :close-on-click-modal="false">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters">
                    <el-form-item >
                        <el-input v-model="filters.conditionSearch" placeholder="Product Name or UPC" clearable @keyup.enter.native="getStorageFeePaymentSummary(warehouseFeeDetailId)" style="width: 400px">
                            <el-button slot="append" icon="el-icon-search" @click="getStorageFeePaymentSummary(warehouseFeeDetailId)"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="exportExcel('/excel/exportWarehouseFeeSummary','Warehouse Fee Summary.xls',1)">Export</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <!--列表-->
            <el-table stripe :data="warehouseFeeSummary" highlight-current-row v-loading="warehouseFeeSummaryLoading" style="width: 100%;">
                <el-table-column prop="productNo" label="Product No">
                </el-table-column>
                <el-table-column prop="productName" label="Product">
                </el-table-column>
                <el-table-column prop="upc" label="UPC">
                </el-table-column>
                <el-table-column prop="inboundFee" label="Inbound Fee">
                    <template slot-scope="scope">
                        ${{formatMoney(scope.row.inboundFee,2)}}
                    </template>
                </el-table-column>
                <el-table-column prop="outboundFee" label="Outbound Fee">
                    <template slot-scope="scope">
                        ${{formatMoney(scope.row.outboundFee,2)}}
                    </template>
                </el-table-column>
                <el-table-column prop="storageFee" label="Storage Fee">
                    <template slot-scope="scope">
                        ${{formatMoney(scope.row.storageFee,2)}}
                    </template>
                </el-table-column>
                <el-table-column prop="reportDate" label="Report Date">
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope" >
                        <el-button size="small" @click="getStorageFeePaymentDetail(scope.row.productNo,1)">
                            Detail
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--工具条-->
            <el-col :span="24" class="toolbar">
                <el-pagination layout="prev, pager, next" @current-change="changeWarehouseFeeSummary"
                               :page-size="pageSize" :total="warehouseFeeSummaryTotal"
                               style="float:right;">
                </el-pagination>
            </el-col>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="warehouseFeeSummaryModelVisible = false;filters.conditionSearch = ''">Close</el-button>
            </div>
        </el-dialog>

        <!--收款列表界面-->
        <el-dialog title="Payment List" width="80%" :visible.sync="paymentListVisible" :close-on-click-modal="false">
        
            <el-col :span="24" class="toolbar">
                <el-form :inline="true" :model="filters">
                    <el-select v-model="filters.paymentStatus" placeholder="Status" @change="getPaymentRequest()"
                                clearable>
                        <el-option label="Pending" value="0"></el-option>
                        <el-option label="Confirmed" value="1"></el-option>
                        <el-option label="Canceled" value="2"></el-option>
                        <el-option label="Archived" value="3"></el-option>
                        <el-option label="Rejected" value="4"></el-option>
                    </el-select>
                    <el-form-item class="pull-right">
                        <el-button type="primary" v-if="!isPaymentPending" v-on:click="showAddPayment">Request a payment</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!--列表-->
            <el-table stripe :data="payments" highlight-current-row v-loading="paymentLoading" style="width: 100%;">
                <el-table-column prop="paymentNo" label="#">
                </el-table-column>
                <el-table-column prop="reportDate" label="Report Date">
                </el-table-column>
                <el-table-column prop="doctorName" label="Company">
                </el-table-column>
                <el-table-column prop="totalFee" label="Total Fee">
                    <template slot-scope="scope">
                        {{formatMoney(scope.row.totalFee,2)}}
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="Apply amount">
                    <template slot-scope="scope">
                        {{formatMoney(scope.row.amount,2)}}
                    </template>
                </el-table-column>
                <el-table-column prop="doctorNote" label="Doctor Note">
                    <template slot-scope="scope" >
                        <div v-html="scope.row.doctorNote"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="warehouseNote" label="Warehouse Note">
                    <template slot-scope="scope" >
                        <div v-html="scope.row.warehouseNote"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" label="Request Date">
                </el-table-column>
                <el-table-column label="Status">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status===0">
                            <el-tag type="info">Pending</el-tag>
                        </p>
                        <p v-if="scope.row.status===1">
                            <el-tag type="success">Confirmed</el-tag>
                        </p>
                        <p v-if="scope.row.status===2">
                            <el-tag type="danger">Canceled</el-tag>
                        </p>
                        <p v-if="scope.row.status===4">
                            <el-tag type="warning">Rejected</el-tag>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope">
                        <el-button size="small" v-if="scope.row.status===0" type="danger"
                                    @click="editPaymentStatus(scope.row.paymentNo,2)" :loading="loading">Cancel
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--工具条-->
            <el-col :span="24" class="toolbar">
                <el-pagination layout="prev, pager, next" @current-change="changePaymentRequest"
                                :page-size="pageSize" :total="paymentTotal"
                                style="float:right;">
                </el-pagination>
            </el-col>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="paymentListVisible = false;filters.paymentStatus = '';getStorageFeePaymentList();">Close</el-button>
            </div>
        </el-dialog>

        <!--发起收款界面-->
        <el-dialog title="Request a payment" width="80%" :visible.sync="requestVisible" :close-on-click-modal="false">
        
            <el-form :model="payment" label-width="220px" ref="payment" :rules="requestFormRules">
                <el-form-item label="Total payment" prop="balance">
                    <el-input-number v-model="payment.balance" :disabled="true"></el-input-number>
                </el-form-item>
                <el-form-item label="Payable amount" prop="amount">
                    <el-input-number v-model="payment.amount" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="Bank Account" prop="bank">
                    <el-select v-model="payment.bank" clearable filterable>
                        <el-option v-for="(bank,index) in banks" :key="index"
                                   :label="bank.category + ' ' +bank.accountNumber+' ('+bank.accountType+')'"
                                   :value="bank.bankNo"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Note" prop="note">
<!--                    <el-input v-model="payment.note" type="textarea" rows="5"></el-input>-->
                    <quill-editor v-model="payment.note" ref="myQuillEditor" :options="editorOption"></quill-editor>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="requestVisible = false">Close</el-button>
                <el-button type="primary" @click.native="requestPayment" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>
        
        <!--重新生成日费用清单界面-->
        <el-dialog title="Rebuild Daily for Storage Fee" width="80%" :visible.sync="requestRebuildVisible" :close-on-click-modal="false">
        
            <el-form :model="rebuildDailyModel" label-width="220px" ref="rebuildDailyModel" :rules="requestFormRules">
                <el-form-item label="Rebuild Date" prop="dates">
                    <el-input v-model="rebuildDailyModel.dates" placeholder="Rebuild dates, example: 2023-09-01,2023-09-02,2023-09-10 etc." clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="requestRebuildVisible = false; rebuildDailyModel.dates = '';">Close</el-button>
                <el-button type="primary" @click.native="rebuildStorageFeeByDaily" :disabled="!isEnable">Rebuild</el-button>
            </div>
        </el-dialog>
        
        <!--重新生成月费用报表界面-->
        <el-dialog title="Rebuild Month for Storage Fee" width="80%" :visible.sync="requestRebuildMonthVisible" :close-on-click-modal="false">
        
        <el-form :model="rebuildMonthModel" label-width="220px" ref="rebuildMonthModel" :rules="requestFormRules">
            <el-form-item label="Rebuild Month" prop="month">
                <el-input v-model="rebuildMonthModel.month" placeholder="Monthly Fee Report Rebuild, example: 2023-09  only one, dont set multiple month`s." clearable></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.native="requestRebuildMonthVisible = false">Close</el-button>
            <el-button type="primary" @click.native="rebuildStorageFeeByMonth" :disabled="!isEnable">Rebuild</el-button>
        </div>
    </el-dialog>
	</section>
</template>


<script>
    import util from '../../common/js/util'
    import {defaultPageSize} from "../../globalVar";
    import {editDiscount, getDiscountList} from "../../api/discountService";
    import {
        getDoctorList,
        getWarehouseList, testGenStorageFeeByMonthly,testGenStorageFeeByDaily,testRebuildStorageFeeByDaily,
        warehouseFeeDetail,
        warehouseFeeSummary
    } from "../../api/storageFeePaymentService";
    import {
        getBankList,
    } from "../../api/paymentService";
    import {
        getPaymentRequest4Warehouse,
        addPaymentRequest4Warehouse,
        editPaymentStatus4Warehouse,
    } from "../../api/paymentService4Warehouse";
    import {postExportExcel} from "../../api/exportService";

    export default {
        data() {
            return {
                firstLoading: false,
                pageSize:defaultPageSize,

                isEnable: true,

                filters:{
                    productName:"",
                    feeType:"",
                    conditionSearch: "",
                    paymentStatus: "",
                    // 按月去查询报表
                    searchMonth: "",
                },

                activeName:"first",


                storageFeePayments:[],

                loading:false,

                warehouseFeeDetail:[],
                warehouseFeeSummary:[],

                storageFeePaymentPage:1,
                storageFeePaymentTotal:0,

                warehouseFeeDetailPage:1,
                warehouseFeeDetailTotal:0,
                warehouseFeeDetailModelVisible:false,

                warehouseFeeSummaryPage:1,
                warehouseFeeSummaryTotal:0,
                warehouseFeeSummaryModelVisible:false,
                
                warehouseFeeLoading:false,
                warehouseFeeSummaryLoading:false,
                warehouseFeeDetailId:null,
                warehouseFeeProductNo:null,
                conditionSearch: "",

                feeTypeList:[
                    {id:0,value:"Inbound"},
                    {id:1,value:"Outbound"},
                    {id:2,value:"Storage"}
                ],

                banks: [],  // 仓库端设置的收款帐户
                requestFormRules: {
                    amount: [
                        {required: true, message: 'Payable amount is required.', trigger: 'blur'},
                        {validator: this.validateAmount, trigger: 'blur'}
                    ],
                    bank: [
                        {required: true, message: '', trigger: 'blur'}
                    ]
                },
                editorOption: {
                    theme: "snow", // or 'bubble'
                    placeholder: "Note",
                    height:"400px",
                    modules: {
                        toolbar: {
                            container: [
                                ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
                                ["link"] // 链接、图片、视频
                            ]
                        }
                    }
                },

                editVisible: false,//编辑界面是否显示
                paymentListVisible: false,//收款列表界面是否显示
                requestVisible: false,//发起收款界面是否显示

                editLoading: false,
                editFormRules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ]
                },
                //编辑界面数据
                editDiscount: {
                    userNo: "",
                    doctorNo: "",
                    doctorName:"",
                    storageFreeDuration: 3,
                    discountRate: 1.00,
                    id:null
                },

                //发起收款界面数据
                paymentPage: 1,
                paymentTotal: 0,
                payment: {
                    amount: 0,
                    bank: "",
                    note: "",
                    balance:0,
                    minPayment:0.1,
                    payStatus: 0,   // 支付状态
                    doctorNo: "",
                    monthlyStorageFeeId: "",  // 总费用ID
                },
                isPaymentPending: false,  // 是否有正在申请支付的记录
                paymentLoading: false,
                payments: [],

                addFormVisible: false,//新增界面是否显示
                addLoading: false,
                formRules: {
                    storageFreeDuration: [
                        { required: true, message: 'Storage Free Duration is required.', trigger: 'blur' }
                    ],
                    discountRate:[
                        { required: true, message: 'Discount Rate is required.', trigger: 'blur' }
                    ]
                },
                user: sessionStorage.getItem('user'),

                // 重新生成日费用清单
                requestRebuildVisible: false,
                rebuildDailyModel: {
                    // 需要重新生成的日期，格式:yyyy-MM-dd, 多个用逗号分隔
                    dates: "",
                },
                // 重新生成月费用报表
                requestRebuildMonthVisible: false,
                rebuildMonthModel: {
                    // 需要重新生成的日期，格式:yyyy-MM-dd, 一次只能一个
                    month: "",
                },

            }
        },
        methods: {
            dateFormat(row,column){
                if(row){
                    let dT=new Date(row);//row 表示一行数据, dateTime 表示要格式化的字段名称
                    return dT.getFullYear()+"-"+(dT.getMonth()+1)+"-"+dT.getDate();
                }else{
                    return "";
                }
            },
            changeSearchMonth(val) {
                this.filters.searchMonth = val;
                this.getStorageFeePaymentList();
            },
            exportExcel(url,fileName,type){
                let param = {
                    url:url,
                    fileName:fileName,
                    doctorNo:window.sessionStorage.getItem("currentCompany"),
                    payNo:this.warehouseFeeDetailId,
                    productNo:this.warehouseFeeProductNo,
                    productName:this.filters.productName,
                    feeType:this.filters.feeType,
                    condition: this.filters.conditionSearch,
                }
                postExportExcel(param).then(function(){

                })
            },
            changeStorageFeePayment(val) {
                this.storageFeePaymentPage = val;
                this.getStorageFeePaymentList();
            },
            formatMoney:function (s, n) {
                n = n > 0 && n <= 20 ? n : 2;
                s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
                var l = s.split(".")[0].split("").reverse();
                let r = s.split(".")[1];
                let t = "";
                if (s < 0) {
                    l = ((Math.abs(s.split(".")[0])) + "").split("").reverse();
                }
                for (let i = 0; i < l.length; i++) {
                    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
                }
                if (s < 0) {
                    t += "-";
                }
                var result =  t.split("").reverse().join("") + "." + r;
                if(result==null||result==undefined||result.indexOf('NaN')>=0||result.indexOf('Undefined')>=0){
                    result = '0.00';
                }
                return result;
            },
            changeWarehouseFeeDetail(val) {
                this.warehouseFeeDetailPage = val;
                this.getStorageFeePaymentDetail(this.warehouseFeeProductNo,val);
            },

            changeWarehouseFeeSummary(val) {
                this.warehouseFeeSummaryPage = val;
                this.getStorageFeePaymentSummary(this.warehouseFeeDetailId);
            },
            getStorageFeePaymentList() {
                let param = {
                    current: this.storageFeePaymentPage,
                    size: this.pageSize,
                    searchMonth: this.filters.searchMonth,
                };
                this.loading = true;
                getWarehouseList(param).then((data) => {
                    this.loading = false;
                    if (data.status === 200) {
                        this.storageFeePayments = data.result.records;
                        this.storageFeePaymentTotal = data.result.total;
                    }
                })
            },
            getStorageFeePaymentDetail(productNo,page) {
                this.warehouseFeeDetailPage = page;
                if(productNo){
                    this.warehouseFeeProductNo= productNo;
                }
                let param = {
                    current: page,
                    size: this.pageSize,
                    payNo:this.warehouseFeeDetailId,
                    productNo:this.warehouseFeeProductNo,
                    productName:this.filters.productName,
                    feeType:this.filters.feeType
                };
                this.warehouseFeeDetailModelVisible = true;
                this.warehouseFeeLoading = true;
                warehouseFeeDetail(param).then((data) => {
                    this.warehouseFeeLoading = false;
                    if (data.status === 200) {
                        this.warehouseFeeDetail = data.result.records;
                        this.warehouseFeeDetailTotal = data.result.total;
                    }
                })
            },
            getStorageFeePaymentSummary(id) {
                this.warehouseFeeDetailId = id;
                let param = {
                    current: this.warehouseFeeSummaryPage,
                    size: this.pageSize,
                    condition: this.filters.conditionSearch,
                    payNo:id
                };
                this.warehouseFeeSummaryModelVisible = true;
                this.warehouseFeeSummaryLoading = true;
                warehouseFeeSummary(param).then((data) => {
                    this.warehouseFeeSummaryLoading = false;
                    if (data.status === 200) {
                        this.warehouseFeeSummary = data.result.records;
                        this.warehouseFeeSummaryTotal = data.result.total;
                    }
                })
            },
            getBankList() {
                getBankList({}).then((data) => {
                    if (data.status === 200) {
                        this.banks = data.result;
                    }
                })
            },
            showPaymentList(row){
                this.payment.balance = row.totalFee;
                this.payment.amount = parseFloat(row.totalFee);
                this.payment.payStatus = row.payStatus;
                this.payment.monthlyStorageFeeId = row.id;
                this.payment.doctorNo = row.doctorNo;
                this.paymentListVisible = true;
                this.getPaymentRequest();
            },
            showAddPayment(){
                this.getBankList();
                this.requestVisible = true;
            },
            requestPayment() {
                this.$refs.payment.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        let param = {
                            amount: this.payment.amount,
                            bankNo: this.payment.bank,
                            doctorNo: this.payment.doctorNo,
                            warehouseNote: this.payment.note,
                            monthlyStorageFeeId: this.payment.monthlyStorageFeeId,
                        };
                        addPaymentRequest4Warehouse(param).then((data) => {
                            this.loading = false;
                            if (data.status === 200) {
                                this.$message.success(data.message);
                                this.requestVisible = false;
                                this.$refs.payment.resetFields();
                                this.getPaymentRequest();
                            }
                        })
                    }
                })
            },
            getPaymentRequest() {
                let param = {
                    current: this.paymentPage,
                    size: this.pageSize,
                    status: this.filters.paymentStatus,
                    doctorNo: this.payment.doctorNo,
                    storageFeeId: this.payment.monthlyStorageFeeId,
                };
                this.paymentLoading = true;
                getPaymentRequest4Warehouse(param).then((data) => {
                    this.paymentLoading = false;
                    this.isPaymentPending = false;
                    if (data.status === 200) {
                        this.payments = data.result.records;
                        this.paymentTotal = data.result.total;
                        console.log('this.payments', this.payments);
                        for (var i = 0; i < this.payments.length; i++) {
                            var p = this.payments[i];
                            if (p.status == 0 || p.status == 1) {
                                // 有正在处理的记录，或者有已支付的记录，不能再发起申请支付请求
                                this.isPaymentPending = true;
                                break;
                            }
                        }
                        console.log('this.isPaymentPending', this.isPaymentPending);
                    }
                })
            },
            changePaymentRequest(val) {
                this.paymentPage = val;
                this.getPaymentRequest();
            },
            editPaymentStatus(paymentNo, status) {
                this.$confirm("Are you sure?", "Warning", {
                    type: "warning"
                }).then(() => {
                    
                    this.loading = true;
                    let param = {
                        paymentNo: paymentNo,
                        status: status
                    };
                    editPaymentStatus4Warehouse(param).then((data) => {
                        this.loading = false;
                        if (data.status === 200) {
                            this.$message.success(data.message);
                            this.getPaymentRequest();
                        } else {
                            this.$message.error(data.message);
                        }
                    })
                }).catch(() => {
                    this.$message.error(data.message);
                })
            },
            validateAmount(rule, value, callback) {
                if (value > 0) {
                    if(value<this.payment.minPayment){
                        callback(new Error('Your payable amount must be greater than $'+this.payment.minPayment+'.'));
                    }else{
                        callback()
                    }
                } else {
                    callback(new Error('Payable amount is required.'));
                }
            },
            testGenStorageFeeByMonthly() {
                if(!this.isEnable) return;

                this.isEnable = false;
                let date = new Date();
                let year = date.getFullYear();
                let month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
                let param = {
                    logId: year + "-" + month
                };
                testGenStorageFeeByMonthly(param).then((data) => {
                    if (data.status === 200) {
                        console.log("操作成功");
                        this.$message.success('Monthly Fee generate success');
                    }
                    setTimeout(() => {
                        this.isEnable = true;
                    }, 5000) // 延迟5s，防止过快的连续点击
                })
            },
            testGenStorageFeeByDaily() {
                if(!this.isEnable) return;

                this.isEnable = false;
                let param = {
                };
                testGenStorageFeeByDaily(param).then((data) => {
                    console.log("操作中...");
                    if (data.status === 200) {
                        console.log("操作成功");
                        this.$message.success('Daily Fee generate success');
                    }
                    setTimeout(() => {
                        this.isEnable = true;
                    }, 5000) // 延迟5s，防止过快的连续点击
                })
            },
            showRebuildStorageFeeByDailyWin() {
                this.requestRebuildVisible = true;
            },
            showRebuildStorageFeeByMonthWin() {
                this.requestRebuildMonthVisible = true;
            },
            rebuildStorageFeeByDaily() {
                if(!this.isEnable) return;

                this.isEnable = false;
                let param = {
                    dates: this.rebuildDailyModel.dates
                };
                testRebuildStorageFeeByDaily(param).then((data) => {
                    if (data.status === 200) {
                        console.log("操作成功");
                        this.$message.success('Rebuild Storage Daily Fee success');
                        this.getPaymentRequest();
                    }
                    setTimeout(() => {
                        this.isEnable = true;
                        this.requestRebuildVisible = false;
                    }, 5000) // 延迟5s，防止过快的连续点击
                })
            },
            rebuildStorageFeeByMonth() {
                if(!this.isEnable) return;

                this.isEnable = false;
                let param = {
                    logId: this.rebuildMonthModel.month
                };
                console.log('aaa ------>', param, this.rebuildMonthModel.month);
                testGenStorageFeeByMonthly(param).then((data) => {
                    if (data.status === 200) {
                        console.log("操作成功");
                        this.$message.success('Rebuild Monthly Fee success');
                        this.getPaymentRequest();
                    }
                    setTimeout(() => {
                        this.isEnable = true;
                        this.requestRebuildMonthVisible = false;
                    }, 5000) // 延迟5s，防止过快的连续点击
                })
            },
        },
        mounted() {
            this.getStorageFeePaymentList();

            let user = sessionStorage.getItem('user')
            user = JSON.parse(user);
            this.user = user;
        }
    }

</script>


// WEBPACK FOOTER //
// payments.vue?03b8b144